<template>
  <div class="g-header-nav" :class="{'in-inner':innerPageShow}">
    <header class="g-header-wrapper">
      <g-header @showmask="showMask"></g-header>
    </header>
    <nav class="g-nav-wrapper">
      <g-nav :show-flag="showMaskFlag" @selectItem="selectNav"></g-nav>
    </nav>
  </div>
</template>

<script type="text/ecmascript-6">
  import header from 'components/common/header/header';
  import nav from 'components/common/nav/nav';
  import {mapMutations, mapGetters} from 'vuex';

  export default {
    props: {
      showMaskFlag: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        innerPageShow: false
      };
    },
    computed: {
//      ...mapGetters([
//        'showMaskFlag'
//      ])
    },
    methods: {
      showMask() {
        this.$emit('maskFlagChange', true);
      },
      hideMask() {
        this.$emit('maskFlagChange', false);
      },
      selectNav() {
        this.hideMask();
      }
//      ...mapMutations({
//        setShowMaskFlag: 'SET_SHOWMASKFLAG'
//      })
    },
    watch: {
      $route(to, from) {
        this.innerPageShow = to.meta.isInnerPage;
      }
    },
    components: {
      'g-header': header,
      'g-nav': nav
    }
  };
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import "~assets/scss/compile";
  @import "./index";

</style>



// WEBPACK FOOTER //
// src/components/common/headerNav/index.vue